require('/ui/components/marketingactivationpage/linkcard.module.scss.module.css');

export const cardBody = "_card-body_f2asq_1";
export const topRow = "_top-row_f2asq_1";
export const headline = "_headline_f2asq_1";
